import Lang from '/@/modules/core/app/services/Lang';
import { ContactUsDetails } from '/@/modules/auth/constants/ContactUsDetails';

export const ContactUsInfoMixin = {
  computed: {
    contactEmail() {
      return ContactUsDetails[Lang.languageLocale].CONTACT_EMAIL;
    },
    termsOfUse() {
      return ContactUsDetails[Lang.languageLocale].TERMS_OF_USE;
    },
    privacyPolicy() {
      return ContactUsDetails[Lang.languageLocale].PRIVACY_POLICY;
    }
  }
};
